var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-wrapper"},[_vm._t("default"),(_vm.isLoading)?_c('div',{staticClass:"loading-wrapper--loader"},[_c('scale-loader',{attrs:{"loading":_vm.isLoading,"color":_vm.$vuetify.theme.primary}})],1):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }